module.exports = __webpack_public_path__ + "img/idcard_zhengmian.c3f14107.png";